module.exports = __webpack_public_path__ + "static/media/0201dco-wireframes.2168485d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0201dco-wireframes.jpg
// module id = 390
// module chunks = 0